import { Footer } from '@components/Footer/Footer';
import Meta from '@components/Meta';
import { NavBar } from '@components/NavBar/NavBar';
import { HearFromYou } from '@components/NHS/HearFromYou';
import { LatestSuccess } from '@components/NHS/LatestSuccess';
import { TransformOutcomes } from '@components/NHS/TransformOutcomes';
import { NhsHero } from '@components/NHS/NhsHero';
import { PublishedData } from '@components/NHS/PublishedData';
import { PartnersAndServices } from '@components/NHS/PartnersAndServices';

import { NHSTranslationType } from '@nextTypes/translations';
import { getStaticTranslationProps } from '@nextUtils/translations';

export const getStaticProps =
  getStaticTranslationProps<NHSTranslationType>('NHS');

const NHS = (): JSX.Element => (
  <>
    <Meta
      title="Second Nature in the NHS"
      metaDescription="Second Nature works with the NHS across the UK. Find out where we are currently available in the NHS and how you can partner with us."
      relativeCanonicalURL="/nhs-and-partnerships"
    />
    <NavBar />
    <NhsHero />
    <TransformOutcomes />
    <PartnersAndServices />
    <PublishedData />
    <LatestSuccess />
    <HearFromYou />
    <Footer />
  </>
);

export default NHS;
